import React from 'react';
import PropTypes from 'prop-types';

import accordionFactory from '../Accordion/AccordionFactory';
import tabDetails from '../Navigation/tabDetails';
import commonStrings from 'resources/commonStrings';

import styles from './GrowthReportFilters.module.css';

import { useAnalytics } from 'hooks/useAnalytics';

const propTypes = {
  filterAccordionDetails: PropTypes.instanceOf(Map).isRequired,
  allReportDetails: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onAccordionStateChange: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  sessionToken: PropTypes.shape().isRequired,
  sortingMethod: PropTypes.string.isRequired,
};

function GrowthReportFilters({
  filterAccordionDetails,
  allReportDetails,
  onAccordionStateChange,
  onResetFilters,
  sessionToken,
  sortingMethod,
}) {
  const handleReset = (event) => {
    event.preventDefault();
    onResetFilters(tabDetails.growthReports.urlEndPoint);
  };

  const handleResetKeystroke = (event) => {
    if (event.key.toLowerCase().indexOf('enter') === 0) {
      handleReset(event);
    }
  };

  const { handleItemClick, handleKeystroke } = useAnalytics(
    'rlp-map-reports',
    'clear-all-filters',
    'filters-sidebar-widget',
    '',
    handleReset,
    handleResetKeystroke
  );

  let canReset = false;

  const filters = [];
  filterAccordionDetails.forEach((value, key, map) => {
    const spaceBetween = filters.length === map.size - 1;

    // we are adding allReportDetails, sortingMethod and mutuallyExclusiveFilterState to
    // the definition so clone the definition first to avoid mutating the state
    const accordionDefinition = Object.assign({}, value);

    accordionDefinition.allReportDetails = allReportDetails;
    accordionDefinition.sortingMethod = sortingMethod;
    accordionDefinition.mutuallyExclusiveFilterState = map.get(
      accordionDefinition.itemState.mutuallyExclusiveFilter.id
    );

    filters.push(
      accordionFactory(
        accordionDefinition,
        key,
        tabDetails.growthReports.urlEndPoint,
        onAccordionStateChange,
        sessionToken,
        spaceBetween
      )
    );
    if (!canReset && accordionDefinition.itemState.value !== accordionDefinition.itemState.defaultValue) {
      canReset = true;
    }
  });

  const resetSpanOpts = {
    role: 'button',
    className: styles['reset'],
    onClick: handleItemClick,
    onKeyUp: handleKeystroke,
  };
  if (canReset) {
    resetSpanOpts.tabIndex = 0;
  }
  const resetSpan = <span {...resetSpanOpts}>{canReset ? commonStrings.filters.resetFilters : null}</span>;

  return (
    <div>
      <div className={styles['section-header']}>
        <span className={styles['title']}>{commonStrings.filters.filterBy}</span>
        {resetSpan}
      </div>
      {filters}
    </div>
  );
}

GrowthReportFilters.propTypes = propTypes;

export default GrowthReportFilters;
